var SessionTokenInterceptor_1;
import { __decorate } from "tslib";
import { Inject, Injectable, InjectionToken } from '@angular/core';
import { HAS_MSAL } from '../guards';
import { ConstructorName } from '../decorators';
import * as i0 from "@angular/core";
import * as i1 from "../services/monitoring.service";
import * as i2 from "ngx-cookie-service";
export const AUTH_URLS = new InjectionToken('auth urls');
let SessionTokenInterceptor = class SessionTokenInterceptor {
  static {
    SessionTokenInterceptor_1 = this;
  }
  monitoringService;
  cookieService;
  hasMsal;
  authUrls;
  constructor(monitoringService, cookieService, hasMsal, authUrls) {
    this.monitoringService = monitoringService;
    this.cookieService = cookieService;
    this.hasMsal = hasMsal;
    this.authUrls = authUrls;
    this.monitoringService.sendTrackEvent(Reflect.getMetadata('constructorName', SessionTokenInterceptor_1), 'constructor');
  }
  intercept(req, next) {
    if (this.hasMsal || !this.authUrls.some(url => req.url.startsWith(url))) {
      return next.handle(req);
    }
    const sessionToken = this.cookieService.get('Authorization');
    const modifiedReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${sessionToken}`
      }
    });
    return next.handle(modifiedReq);
  }
  static ɵfac = function SessionTokenInterceptor_Factory(t) {
    return new (t || SessionTokenInterceptor)(i0.ɵɵinject(i1.MonitoringService), i0.ɵɵinject(i2.CookieService), i0.ɵɵinject(HAS_MSAL), i0.ɵɵinject(AUTH_URLS));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SessionTokenInterceptor,
    factory: SessionTokenInterceptor.ɵfac
  });
};
SessionTokenInterceptor = SessionTokenInterceptor_1 = __decorate([ConstructorName('SessionTokenInterceptor')], SessionTokenInterceptor);
export { SessionTokenInterceptor };
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SessionTokenInterceptor, [{
    type: Injectable
  }], () => [{
    type: i1.MonitoringService
  }, {
    type: i2.CookieService
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [HAS_MSAL]
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [AUTH_URLS]
    }]
  }], null);
})();
